/*
* @Author: 王春岩 <Bolt>
* @Date:   2017-05-16 14:33:30
* @Last Modified by:   Bolt
* @Last Modified time: 2017-05-16 14:48:10
*/

'use strict';

export default {};

export const VueParent = {};



// WEBPACK FOOTER //
// ./~/@souche-f2e/weidian-util-vue-layer/src/stores.babel.js